import { Typeform } from 'types/MarketplaceAdResponse';

export const getTypeFormTitle = (typeform: Typeform[], refCategory: string): string => {
  const typeformItem = typeform.find((item) => item.ref === refCategory);

  if (typeformItem) {
    return typeformItem.title;
  }

  return '';
};

export const getTypeFormValues = (typeform: Typeform[], refCategory: string): Array<string> => {
  const typeformAccessories = typeform.find((item) => item.ref === refCategory);

  if (typeformAccessories && typeformAccessories.values) {
    return typeformAccessories.values.reduce<Array<string>>(
      (acc, curr) => [...acc, curr.value],
      []
    );
  }
  return [];
};
